<template>
    <b-container>
        <b-table
            :fields="fields"
            class="efedros-table" show-empty :items="importsList"
            :current-page="currentPage"
            :per-page="0"
            empty-text="Δεν υπάρχουν εγγραφές"
        >
            <template #cell(errors)="row">
                <b-button size="sm" variant="outline-primary" @click="downloadErrors(row.item)">
                    <b-icon icon="download"></b-icon>
                </b-button>
            </template>
        </b-table>
        <b-pagination v-if="totalItems>0" size="md" :total-rows="totalItems" @change="pageChange"
                      v-model="currentPage"
                      :per-page="perPage"></b-pagination>
    </b-container>
</template>

<script>

export default {
    name: "DiavImportList",
    components: {},
    props: {
        isArchived: Boolean,
        isActive: Boolean
    },
    data() {
        return {
            importsList: [],
            totalItems: 0,
            fields: [
                {
                    key: 'metadataKwd',
                    label: 'Κωδικός'
                },
                {
                    key: 'adiavImportTypesByTypeKwd.typeLek',
                    label: 'Τύπος'
                },
                {
                    key: 'startDate',
                    label: 'Ημερομηνία εκκίνησης'
                },
                {
                    key: 'finishDate',
                    label: 'Ημερομηνία λήξης'
                },
                {
                    key: 'success',
                    label: 'Επιτυχής'
                },
                {
                    key: 'stage',
                    label: 'Βήμα',
                },
                {
                    key: 'reason',
                    label: 'Σχόλιο',
                    tdClass: 'reason-col'
                },
                {
                    key: 'errors',
                    label: 'Σφάλματα',
                },
            ],
            currentPage: 0,
            perPage: 10,
        }
    },
    mounted() {
        this.fetchData();
    },
    computed: {
        role: function () {
            return this.$store.getters.userRole;
        }
    },
    methods: {
        downloadErrors(item) {
            let url = `/diav/imports/failed/download/${item.metadataKwd}`;
            this.$store.dispatch('loading');
            this.$http({
                url: url,
                method: 'GET',
                responseType: 'blob',
            }).then((response) => {
                // this.$store.commit('set_token', response.headers.jwt);
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "errors.jsonl");
                this.$store.dispatch('stop_loading');
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
            }).catch((e) => {
                console.error(e);
                this.$store.dispatch('stop_loading');
            });
        },
        pageChange(page) {
            this.currentPage = page - 1;
            this.fetchData()
        },
        fetchData: function () {
            let size = this.perPage == null ? 10 : this.perPage;
            let page = this.currentPage == null ? 0 : this.currentPage

            if (this.isActive) {
                this.$store.dispatch('loading');
                this.$http.get(`/diav/imports/active?page=${page}&size=${size}`)
                    .then((response) => {
                        let data = response.data.responseData
                        this.importsList = data.content;
                        this.totalItems = data.totalElements
                    })
                    .catch((e) => {
                        console.log(e)
                    })
                    .finally(() => this.$store.dispatch('stop_loading'))
            } else if (this.isArchived) {
                this.$store.dispatch('loading');
                this.$http.get(`/diav/imports/archived?page=${page}&size=${size}`)
                    .then((response) => {
                        let data = response.data.responseData
                        this.importsList = data.content;
                        this.totalItems = data.totalElements
                    })
                    .catch((e) => {
                        console.log(e)
                    })
                    .finally(() => this.$store.dispatch('stop_loading'))
            }
        }
    }
}
</script>

<style>
.reason-col {
    white-space: nowrap;
    max-width: 100px;
    overflow: auto;
}
</style>